import { Language } from '@/context/language';
import { DOMAIN, COUNTRY } from './constant';

export const getContactUsLink = (lang: Language) => {
  return `${DOMAIN}/${COUNTRY}/${lang}/home/support/contact-us.html`;
};
